<script setup>
import { useCategoryStore } from "~/store/CategoryStore";
import { useFilterStore } from "~/store/FilterStore";
import { useUserStore } from "~/store/UserStore";
import { useUtilityStore } from "~/store/UtililityStore";


const props = defineProps([
    "categorySidebarShow"
]);
const router = useRouter();
const filterStore = useFilterStore()
const utilityStore = useUtilityStore();
const categoryStore = useCategoryStore();
const lables = computed(() => categoryStore.categoryLables)
const filters = computed(() => categoryStore.fullCategoryFilters)
const userStore = useUserStore();
const categoriesPreference = computed(() => userStore.categoriesPreference);
const toggleCategory = ref({ key: false });
const selectedLanguage = computed(() => utilityStore.selectedLanguage)
const categoryfilterState = computed(() => filterStore.categoryfilterState)
const localePath = useLocalePath();

const menuOpen = ref(false);
const closeTimer = ref(null);
const openMenu = () => {
    if (closeTimer.value) {
        clearTimeout(closeTimer.value);
        closeTimer.value = null;
    }
    menuOpen.value = true;
    if (toggleCategory.value.key === false && activeCategoryFiltersOnly.value?.length) {
        toggleCategory.value = { key: 0 };
    }
}
const closeMenu = () => {
    if (closeTimer.value) {
        clearTimeout(closeTimer.value);
        closeTimer.value = null;
    }
    menuOpen.value = false;
    toggleCategory.value = { key: false };
}
const scheduleClose = (delayMs = 160) => {
    if (closeTimer.value) clearTimeout(closeTimer.value);
    closeTimer.value = setTimeout(() => {
        closeMenu();
    }, delayMs);
}
const toggleMenu = () => {
    if (menuOpen.value) closeMenu();
    else openMenu();
}

const activeCategoryFiltersOnly = computed(() => {

    return filters.value && filters.value?.filter ? filters.value?.filter(
        (x) =>
            !categoriesPreference.value[x.key] ||
            !categoriesPreference.value[x.key].status === false
    ) : [];
})
const childAggregated = computed(() => activeCategoryFiltersOnly.value?.map(x => x['child_agg']['buckets']))


const getLable = computed(() => {
    return (key) => {
        if (
            lables.value[key] &&
            Object.prototype.hasOwnProperty.call(
                lables.value[key],
                selectedLanguage.value
            )
        ) {
            return lables.value[key][selectedLanguage.value];
        } else if (
            lables.value[key] &&
            Object.prototype.hasOwnProperty.call(lables.value[key], "fr_BE")
        ) {
            return lables.value[key]["fr_BE"];
        } else return key;
    };
})
const expandHandler = (filterKey, isParent = false, parentname = "") => {
    EventBus.emit("setExpandCategory", { filterKey, isParent, parentname });
}
const performFiltering = () => {
    const filterv = Object.values(categoryfilterState.value.grandchild)
        .filter((x) => x.value === true && x.key)
        .map((k) => k.key);

    filterStore.setSelectedCategoryFilters(filterv);



}
const handleFilterChildMulti = ({ parent, childBuckets }) => {
    const checked = true;
    let _parent = {},
        _child = {},
        _grandchild = {};
    for (let i = 0; i < childBuckets.length; i++) {
        if (
            childBuckets[i].sub_child_agg &&
            childBuckets[i].sub_child_agg.buckets.length
        ) {
            _grandchild = {
                ..._grandchild,
                ...Object.assign(
                    {},
                    ...childBuckets[i].sub_child_agg.buckets.map((x) => {
                        return {
                            [x.key]: { value: checked, show: checked, key: x.key },
                        };
                    })
                ),
            };
            _child = {
                ..._child,
                [childBuckets[i].key]: { value: checked, show: checked },
            };
        } else {
            _grandchild = {
                ..._grandchild,
                [childBuckets[i].key]: {
                    value: checked,
                    show: checked,
                    key: childBuckets[i].key,
                },
            };
        }
    }
    filterStore.setCategoryfilterState({
        parent: {
            [parent]: { value: checked, show: checked },
        },
        child: { ..._child, all: true },
        grandchild: {
            ..._grandchild,
        },
    });

    setTimeout(() => {
        router.push({ path: localePath('/products/search') })
    }, 500);
    setTimeout(() => {
        expandHandler(parent, true);
        performFiltering();
    }, 800);
}
const ParentCategoryHandler = (filter) => {
    const childBuckets = activeCategoryFiltersOnly.value.find(x => x.key === filter.key)['child_agg']['buckets'] //.map(x => x.buckets);//.map(x => x.key)
    handleFilterChildMulti({ childBuckets, parent: filter.key })
}


const ChildCategoryHandler = (childCategory) => {
    // console.log("filter child category", childCategory);
    // console.log("filter Subchild category", childCategory);
    // console.log("category", activeCategoryFiltersOnly.value);
    let topParent;
    for (let i = 0; i < activeCategoryFiltersOnly.value.length; i++) {
        const buckets = activeCategoryFiltersOnly.value[i].child_agg.buckets
        topParent = buckets.find(x => x.key === childCategory.key)
        if (topParent) {
            topParent = activeCategoryFiltersOnly.value[i].key
            break;
        }
    }
    // console.log("filter child category", childCategory);
    // console.log("topParent", topParent);

    const checked = true;
    let _child = {}, _grandchild = {};

    if (childCategory['sub_child_agg']['buckets'].length) {
        _grandchild = {
            ...Object.assign(
                {},
                ...childCategory['sub_child_agg']['buckets'].map((x) => {
                    return {
                        [x.key]: { value: checked, show: checked, key: x.key },
                    };
                })
            ),
        };
        _child = {
            [childCategory.key]: { value: checked, show: checked },
        };
    }
    else {
        _grandchild = {
            [childCategory.key]: {
                value: checked,
                show: checked,
                key: childCategory.key,
            },
        };
    }
    filterStore.setCategoryfilterState({
        parent: {
            [topParent]: { value: checked, show: checked },
        },
        child: { ..._child, all: true },
        grandchild: {
            ..._grandchild,
        },
    });


    setTimeout(() => {
        router.push({ path: localePath('/products/search') })
    }, 500);
    setTimeout(() => {
        expandHandler(childCategory.key, false, topParent);
        performFiltering();
    }, 800);
}
// useAsyncData('fetch-all-categories', async () => {
//    return await categoryStore.fetchAllCategories()
// });
onBeforeMount(() => {
    categoryStore.fetchAllCategories();
});
const getImgPath = (key) => `/category-images/${key}.svg`
</script>
<template>

    <div class="relative inline-block">
        <button type="button"
            class="inline-flex items-center gap-2 px-4 py-2 bg-[#009d66] text-white rounded-xl text-sm font-bold uppercase tracking-wide hover:bg-[#008556] transition-all shadow-md items-center h-[50px]"
            aria-haspopup="menu"
            :aria-expanded="menuOpen"
            @click="toggleMenu"
            @mouseenter="openMenu"
            @mouseleave="scheduleClose()"
            @focus="openMenu">
            <i class="fa fa-bars"></i>
            <span>{{ $t('common.categories', 'Categories') }}</span>
            <i class="fa fa-caret-down opacity-50"></i>
        </button>

        <div v-show="menuOpen"
            class="absolute left-0 top-full z-50 mt-2 w-[min(980px,calc(100vw-2rem))] overflow-hidden rounded-xl border border-gray-100 bg-white shadow-2xl ring-1 ring-black ring-opacity-5"
            @mouseenter="openMenu"
            @mouseleave="scheduleClose()">
            <div class="grid grid-cols-1 md:grid-cols-4">
                <!-- Left: parents -->
                <div class="md:col-span-1 border-b md:border-b-0 md:border-r border-gray-200 bg-gray-50">
                    <ul class="max-h-[60vh] overflow-auto py-2">
                        <li v-for="(filter, index) in activeCategoryFiltersOnly" :key="filter.key">
                            <button type="button"
                                class="group w-full px-4 py-2 text-left text-sm hover:bg-[#009d66] hover:text-white transition-colors"
                                @mouseenter="toggleCategory = { key: index }"
                                @focus="toggleCategory = { key: index }"
                                @click.prevent="() => { ParentCategoryHandler(filter); closeMenu(); }">
                                <span class="flex items-center justify-between gap-3">
                                    <span class="flex min-w-0 items-center gap-2">
                                        <NuxtImg
                                            :src="getImgPath(filter.key)"
                                            class="cld-keep-light ml-1 h-6 w-6 shrink-0 rounded-full bg-white p-1 shadow-sm ring-1 ring-green-200 object-contain" />
                                        <span class="truncate">{{ getLable(filter.key) }}</span>
                                    </span>
                                    <span class="flex shrink-0 items-center gap-2 text-xs text-gray-500 group-hover:text-white">
                                        <span>+{{ filter.doc_count }}</span>
                                        <i class="fa fa-angle-right text-[#009d66]/80 group-hover:text-white"  aria-hidden="true"></i>
                                    </span>
                                </span>
                            </button>
                        </li>
                    </ul>
                </div>

                <!-- Right: children -->
                <div class="md:col-span-3">
                    <div class="max-h-[60vh] overflow-auto p-3">
                        <div v-if="toggleCategory.key === false" class="text-sm text-gray-500">
                            Hover a category to see sub-categories.
                        </div>
                        <ul v-for="(childCategories, ic) in childAggregated"
                            :key="`child-${ic}`"
                            v-show="toggleCategory.key === ic"
                            class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
                            <li v-for="childCategory in childCategories" :key="childCategory.key">
                                <button type="button"
                                    class="group w-full px-4 py-2 text-left rounded-lg transition-colors hover:bg-[#009d66]"
                                    @click.prevent="() => { ChildCategoryHandler(childCategory); closeMenu(); }">
                                    <span class="flex items-center gap-3">
                                        <i class="fa fa-tag text-[#009d66]/70 group-hover:text-white text-xs" aria-hidden="true"></i>
                                        <span class="min-w-0 flex-1 truncate text-gray-700 text-xs group-hover:text-white">{{ getLable(childCategory.key) }}</span>
                                        <span class="flex shrink-0 items-center justify-center h-5 px-1.5 rounded-full bg-gray-100 text-[10px] font-bold text-gray-500">
                                            {{ childCategory.doc_count }}
                                        </span>
                                    </span>
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
